export const beforeAfterData = {
  beforeImage:
    'https://images.myloapp.in/NestJsUploads/1710305131113-Before.webp',
  afterImage:
    'https://images.myloapp.in/NestJsUploads/1710305259801-After.webp',
  heading: 'Clinical Results of Mylo Care Stretch Marks Cream',
  description:
    'Study done by an NABL Accredited Lab on 100 Post Delivery Woman Over 84 Days',
  footer: 'Stretch mark perimeter reduction results',
  defaultValue: 70,
};

export const reportsData = {
  heading: 'After 84 days, women reported:',
  reports: [
    {
      metric: '9/10',
      description: 'visible reduction in stretch marks',
    },
    {
      metric: '91%',
      description: 'improved skin smoothness',
    },
    {
      metric: '92%',
      description: 'reported better moisturized & nourished skin',
    },
    {
      metric: '9/10',
      description: 'improvement in overall skin appearance',
    },
  ],
};
